<template>
  <div class="game-details-skeleton">
    <div class="hero">
      <SkeletonBlock width="220px" height="22px" />
      <SkeletonBlock width="180px" height="18px" />
      <div class="teams">
        <div class="team">
          <SkeletonBlock width="96px" height="96px" />
          <SkeletonBlock width="110px" height="18px" />
        </div>
        <SkeletonBlock width="24px" height="16px" />
        <div class="team">
          <SkeletonBlock width="96px" height="96px" />
          <SkeletonBlock width="110px" height="18px" />
        </div>
      </div>
    </div>

    <div class="grid">
      <SkeletonBlock v-for="card in 3" :key="card" width="100%" height="116px" :rounded="false" />
    </div>
    <div class="grid">
      <SkeletonBlock v-for="card in 4" :key="`metric-${card}`" width="100%" height="160px" :rounded="false" />
    </div>
    <SkeletonBlock width="100%" height="180px" :rounded="false" />
  </div>
</template>

<script>
import SkeletonBlock from "./SkeletonBlock.vue";

export default {
  name: "GameDetailsSkeleton",
  components: {
    SkeletonBlock,
  },
};
</script>

<style scoped>
.game-details-skeleton {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.hero,
.team {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.hero {
  gap: 12px;
}

.teams {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 20px;
  width: 100%;
}

.team {
  gap: 10px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

@media (max-width: 768px) {
  .grid {
    grid-template-columns: 1fr;
  }
}
</style>
